<template>
  <div class="card-nav">
    <ul>
      <li :class="date === 'today' ? 'active' : 'deactivate'">
        <router-link @click="e => handleActiveChangeProducts(e, 'today')" to="#">
          {{ $t('common.today') }}
        </router-link>
      </li>
      <li :class="date === 'week' ? 'active' : 'deactivate'">
        <router-link @click="e => handleActiveChangeProducts(e, 'week')" to="#">
          {{ $t('common.week') }}
        </router-link>
      </li>
      <li :class="date === 'month' ? 'active' : 'deactivate'">
        <router-link @click="e => handleActiveChangeProducts(e, 'month')" to="#">
          {{ $t('common.month') }}
        </router-link>
      </li>
      <li :class="date === 'year' ? 'active' : 'deactivate'">
        <router-link @click="e => handleActiveChangeProducts(e, 'year')" to="#">
          {{ $t('common.year') }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
    emits: ['dateChanged'],
    methods: {
        handleActiveChangeProducts(e, value) {
            this.date = value;
            this.$emit('dateChanged', this.date);
        }
    },
    data() {
        return {
            date: 'year',
        }
    }
}
</script>